import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
import { LocationProvider } from "./locationData";

ReactDOM.render(
  <React.StrictMode>
    <LocationProvider>
      <App />
    </LocationProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
